import moment from "moment";

export const checkIfDateIsToday = dateString => {
  if(!dateString) return false
  const today = moment().format("DD/MM/YYYY")
  return dateString === today
}